<template>
    <article>
        <p>
            One service can't connect to another (or can't establish a database connection) - underneath this simple definition,
            there can be two very different conditions.
        </p>

        <p>
            <b>First</b> - we may have a service process down. In this case, the Kernel stack is operational,
            so we are getting the packet back, indicating the connection was refused.
        </p>

        <p>
            <b>Second</b> - when network flow is completely disrupted due to connectivity issues, firewall,
            or a node being completely down. In this case, we do not get any response whatsoever.
        </p>

        <p>
            Before the update, while Coroot had metrics and presented them in charts, it would not specifically identify them as issues.
        </p>

        <v-card max-width="1200px" class="pa-5 my-6">
            <v-img eager class="ma-auto" src="/static/img/blog/better_network_observability.png" />
        </v-card>

        <p>
            In the <a href="https://github.com/coroot/coroot/releases/tag/v0.29.5" target="_blank">Coroot 0.29.5 release</a>,
            we added automatic inspections for these issues, so users no longer have to analyze charts manually.
        </p>

        <p>
            If you're interested to learn more about Network Failures and how Coroot identifies them,
            check out our previous articles on <a href="/blog/chaos-driven-observability-spotting-network-failures" target="_blank">Spotting Network Failures in Kubernetes</a> and
            <a href="/blog/how-to-ping" target="_blank">Measuring Network Round Trip Time Precisely</a>.
        </p>
    </article>
</template>

<script>
export default {
}
</script>

<style scoped>
</style>
